import { computed } from 'vue';
import { useRoute } from 'vue-router';

export function useInvitation() {
    const route = useRoute();
    return computed(() => route.query.ref ?? '');
}
